// extracted by css-extract-rspack-plugin
export default {"traceTable":"TraceTable-module__traceTable__EAuU7"};